export class BaseWorkflowDefinition {
    constructor() {
        this.MAX_ACTION_GROUPS = 100;
    }
    validate(workflow) {
        const errors = [];
        const warnings = [];
        // Validate filters
        const allowedFields = this.filters.map(f => f.field);
        const usedFields = workflow.filterConditions?.map((f) => f.field) || [];
        // Check for invalid fields
        const invalidFields = usedFields.filter((f) => !allowedFields.includes(f));
        if (invalidFields.length > 0) {
            errors.push(`Invalid filter fields: ${invalidFields.join(', ')}`);
        }
        // Check required filters
        const requiredFields = this.filters
            .filter(f => f.required)
            .map(f => f.field);
        const missingRequired = requiredFields.filter(f => !usedFields.includes(f));
        if (missingRequired.length > 0) {
            errors.push(`Missing required filters: ${missingRequired.join(', ')}`);
        }
        // Validate action groups
        if (workflow.actionGroups) {
            if (workflow.actionGroups.length > this.MAX_ACTION_GROUPS) {
                errors.push(`Too many action groups: ${workflow.actionGroups.length} (max: ${this.MAX_ACTION_GROUPS})`);
            }
            // For INTERPRETED workflows, ensure selection criteria exists
            if (this.actionType === 'INTERPRETED' &&
                workflow.actionGroups.length > 1) {
                for (const group of workflow.actionGroups) {
                    if (!group.selectionCriteria) {
                        warnings.push(`Action group "${group.name || group.id}" lacks selection criteria for LLM interpretation`);
                    }
                }
            }
        }
        return {
            isValid: errors.length === 0,
            errors,
            warnings: warnings.length > 0 ? warnings : undefined,
        };
    }
}
//# sourceMappingURL=base-workflow-definition.js.map